import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex items-center justify-center">
      <div className="text-center px-4">
        <div className="w-24 h-24 mx-auto rounded-full bg-background-100 flex items-center justify-center mb-6">
          <i className="ri-emotion-sad-line text-4xl text-foreground-400"></i>
        </div>
        <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">页面未找到</h1>
        <p className="text-foreground-500 mb-8 max-w-md mx-auto">
          抱歉，您要查找的页面不存在或已被移除。请检查链接是否正确，或返回首页继续浏览。
        </p>
        <Link
          to="/"
          className="inline-flex items-center px-6 py-3 text-sm font-medium rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-4-line mr-2"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}